import vue from 'vue';

vue.filter('strlen', (value, length = -1, replace = '...') => {
  if (length === -1) {
    return value;
  }
  const rest = value.slice(length);
  const nextSpaceIndex = Math.min(rest.indexOf(' '), rest.indexOf('.'));
  return value.slice(0, length + nextSpaceIndex) + replace;
});



// WEBPACK FOOTER //
// ./src/filters/strlen.filter.js